import { getAcsEvent } from "@/services/user.service";
import { getControllersEvents } from "@/services/device.service";
import { downloadXLS } from "./excel.service";
import { getUserById } from "./user.service";
import { getTypesName } from "@/constants/events-type.constants";

let typeEvent = {
  "1": "Вход",
  "2": "Выход",
  "200": "Доступ запрещен"
};

function formatEventByValue(value) {
  return value ? typeEvent[value] : "пусто";
}

function formatController(value) {
  return value ? value.name : "пусто";
}

function formatNameFile(user, params) {
  let name = `${user.surname} ${user.name?.slice(0, 1)?.toUpperCase() ||
    ""} ${user.patronymic?.slice(0, 1)?.toUpperCase() || ""}`.trim();

  return `${name} ${params.dateBegin} - ${params.dateEnd}.xlsx`;
}

function formatDate(data) {
  return new Date(data.date).toLocaleString();
}

function formatDateTime(date, time) {
  return `${date} ${time}`;
}

function formatEvent(data) {
  return data.eventName.toLowerCase();
}

function formatName(data) {
  return `${data.surname || ""} ${data.name || ""} ${data.patronymic ||
    ""}`.trim();
}

function createTitle() {
  return [
    {
      value:
        "Кампусная система ФГБОУ ВО «Благовещенский Государственный Педагогический Университет»",
      width: 100,
      colspan: 5,
      font: {
        size: 12,
        bold: true
      },
      align: "center"
    }
  ];
}

function createHeader(user, params) {
  return [
    [
      { colspan: 2 },
      {
        value: "ФИО:",
        font: { bold: true }
      },
      {
        value: formatName(user)
      }
    ],
    [
      { colspan: 2 },
      {
        value: "От:",
        font: { bold: true }
      },
      {
        value: formatDateTime(params.dateBegin, params.timeBegin)
      },
      {
        value: "До:",
        font: { bold: true }
      },
      {
        value: formatDateTime(params.dateEnd, params.timeEnd)
      }
    ],
    [
      { colspan: 2 },
      {
        value: "Контроллер:",
        font: { bold: true }
      },
      {
        value: formatController(params.controller)
      },
      {
        value: "Тип события:",
        font: { bold: true }
      },
      {
        value: formatEventByValue(params.typeEvent)
      }
    ]
  ];
}

function createSeparator() {
  return [{ colspan: 5 }];
}

function formatRows(data, user, params) {
  let rows = [];

  rows.push(createTitle());

  rows.push(createSeparator());

  rows.push(...createHeader(user, params));

  rows.push(createSeparator());

  rows.push([
    {
      value: "№",
      header: true,
      width: 5
    },
    {
      value: "Дата",
      header: true,
      width: 20
    },
    {
      value: "Контроллер",
      header: true,
      width: 25
    },
    {
      value: "Шлюз",
      header: true,
      width: 25
    },
    {
      value: "Событие",
      header: true,
      width: 25
    }
  ]);

  for (let i = 0; i < data.length; i++) {
    rows.push([
      {
        value: i + 1
      },
      {
        value: formatDate(data[i])
      },
      {
        value: data[i].controllerName
      },
      {
        value: data[i].gatewayName
      },
      {
        value: formatEvent(data[i])
      }
    ]);
  }

  return rows;
}

function createControllerTitle() {
  return [
    {
      value:
        "Кампусная система ФГБОУ ВО «Благовещенский Государственный Педагогический Университет»",
      width: 100,
      colspan: 7,
      font: {
        size: 12,
        bold: true
      },
      align: "center"
    }
  ];
}

function createControllerSeparator() {
  return [{ colspan: 7 }];
}

function createControllerInfoRows(params) {
  const rows = [];
  if (params.dateBegin || params.dateEnd) {
    rows.push([
      { colspan: 5 },
      { value: "Период:", font: { bold: true } },
      { value: `${params.dateBegin || "…"} — ${params.dateEnd || "…"}` }
    ]);
  }
  if (params.pointName) {
    rows.push([
      { colspan: 5 },
      { value: "Точка доступа:", font: { bold: true } },
      { value: params.pointName }
    ]);
  }
  if (params.controllerName) {
    rows.push([
      { colspan: 5 },
      { value: "Контроллер:", font: { bold: true } },
      { value: params.controllerName }
    ]);
  }
  if (params.categoryTypeName) {
    rows.push([
      { colspan: 5 },
      { value: "Категория:", font: { bold: true } },
      { value: params.categoryTypeName }
    ]);
  }
  if (params.identifierTypes) {
    rows.push([
      { colspan: 5 },
      { value: "Типы идентификаторов:", font: { bold: true } },
      { value: params.identifierTypes }
    ]);
  }
  return rows;
}

function formatControllerRows(data, meta) {
  const rows = [];

  rows.push(createControllerTitle());
  rows.push(createControllerSeparator());
  rows.push(...createControllerInfoRows(meta.params));
  rows.push(createControllerSeparator());

  rows.push([
    { value: "№", header: true, width: 5 },
    { value: "Дата", header: true, width: 20 },
    { value: "Контроллер", header: true, width: 20 },
    { value: "ФИО", header: true, width: 25 },
    { value: "Тип идентификатора", header: true, width: 20 },
    { value: "Шлюз", header: true, width: 15 },
    { value: "Событие", header: true, width: 15 }
  ]);

  for (let i = 0; i < data.length; i++) {
    rows.push([
      { value: i + 1 },
      { value: formatDate(data[i]) },
      { value: data[i].controllerName },
      {
        value: data[i].userId
          ? `${data[i].surname || ""} ${data[i].name || ""}`.trim() || "—"
          : "—"
      },
      { value: getTypesName(data[i].type) },
      { value: data[i].gatewayName },
      { value: formatEvent(data[i]) }
    ]);
  }

  return rows;
}

async function downloadControllerEvents({ totalElements, params }) {
  const queryParams = {
    page: 0,
    size: totalElements,
    dateBegin: params.dateBegin || "null",
    dateEnd: params.dateEnd || "null",
    cId: params.cId || -1,
    pId: params.pId || -1,
    categoryType: params.categoryType || "null",
    identifierTypes: params.identifierTypes || "all"
  };

  const data = await getControllersEvents(queryParams);

  const infoParams = { ...params };
  if (infoParams.categoryType === "ENTRANT")
    infoParams.categoryTypeName = "Студенты";
  else if (infoParams.categoryType === "STAFF")
    infoParams.categoryTypeName = "Сотрудники";
  else if (infoParams.categoryType === "PPS")
    infoParams.categoryTypeName = "ППС";

  await downloadXLS(
    formatControllerRows(data.content, { params: infoParams }),
    `События СКУД ${params.dateBegin || ""} — ${params.dateEnd || ""}.xlsx`
      .replace(/ — $/, "")
      .replace(/^ — /, "")
  );
}

async function downloadAccessEvent({
  userId,
  time,
  date,
  selectControllerId,
  selectEventType,
  totalElements,
  controller
}) {
  let params = {
    page: 0,
    size: totalElements,
    timeBegin: time.begin,
    timeEnd: time.end,
    dateBegin: date?.begin,
    dateEnd: date?.end,
    cId: selectControllerId,
    typeEvent: selectEventType,
    controller: controller
  };

  let data = await getAcsEvent(userId, params);
  let user = await getUserById(userId);

  await downloadXLS(
    formatRows(data.content, user, params),
    formatNameFile(user, params)
  );
}

export { downloadAccessEvent, downloadControllerEvents };
